import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';

export class ReportHeader extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      title: `string`,
      description: `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const ReportHeaderEl = defineAndMakeJsxFactory(`mp-report-header`, ReportHeader);
